import { render, staticRenderFns } from "./ed-divider.vue?vue&type=template&id=173a0107&"
import script from "./ed-divider.ts?vue&type=script&lang=ts&"
export * from "./ed-divider.ts?vue&type=script&lang=ts&"
import style0 from "./ed-divider.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports